import { InjectionToken } from '@angular/core';
import { TwaInAppReviewConfigLoader } from './types';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const TWA_IN_APP_REVIEW_CONFIG_LOADER: InjectionToken<TwaInAppReviewConfigLoader> =
  new InjectionToken<TwaInAppReviewConfigLoader>('twaInAppReviewConfig');
